import { Link, useNavigate } from "react-router-dom";
import Error from "../../assets/images/error.png";

export default function ErrorPage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="error-wrap">
        <div>
          <h1>Something went wrong</h1>
          <Link onClick={() => navigate(-1)}>TRy Again</Link>
          <img src={Error} />
        </div>
      </div>
    </>
  );
}
